import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { css } from "@emotion/react";
import { Typography } from "@material-ui/core";
import { colors, mq_max_width } from "../../utils/emotion-variables";
import { BundleCardBenefitItem } from "./BundleCardBenefitItem";
import { BundleCardBaseCard } from "./BundleCardBaseCard";
import { BundleCardButton } from "./BundleCardButton";

const __outerContainer = css`
  width: 340px;
  border-radius: 6px;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.03);
  ${mq_max_width[1]} {
    width: 100%;
  }
`;

const __imageContainer = css`
  margin: -1px;
  display: flex;
  flex-shrink: 0;
`;

const __centerText = css`
  text-align: center;
`;

const __lineHeight = css`
  line-height: 22px;
`;

const __cardTitle = css`
  color: ${colors.darkGrey};
  ${mq_max_width[1]} {
    margin-top: 10px;
  }
`;

const __benefitItems = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8px;
  margin: 20px 0 16px;
  ${mq_max_width[1]} {
    gap: 6px;
    min-height: 190px;
  }
`;

interface BundleCardProps {
  title: string;
  isComingSoon: boolean;
  variants: string[];
  actionCTA: string;
  buttonClickHandler: () => void;
  background?: "teal" | "pink";
  highlights: string[];
}

export const BundleCard= ({
  isComingSoon,
  title,
  variants,
  actionCTA,
  buttonClickHandler,
  highlights,
  background = "pink"
}: BundleCardProps) => {
  const image =
    background === "pink" ? (
      <StaticImage
        src="https://cdn.shopify.com/s/files/1/1540/8825/files/dip-nail-kit.jpg?v=1691263610"
        alt={title}
        className="img-fluid"
      />
    ) : (
      <StaticImage
        src="https://cdn.shopify.com/s/files/1/1540/8825/files/dipgel-kit.jpg?v=1691263610"
        alt={title}
        className="img-fluid"
      />
    );
  return (
    <div css={__outerContainer}>
      <BundleCardBaseCard background={background}>
      <Typography variant="caption" style={{ fontSize: '1.3rem' }}>{title.toLowerCase().includes('dip nail kit') ? 'The Original' : 'Easiest At-Home'}</Typography>
        <Typography
          css={css`
            ${__centerText};
            ${__cardTitle};
            ${__lineHeight};
          `}
          variant="h4"
          color="textPrimary"
        >
          {title}
        </Typography>
        {variants.map(variant => (
          <Typography
            css={css`
              ${__centerText};
              ${__lineHeight};
            `}
            variant="body2"
            key={`${variant}-${title}`}
          >
            {variant}
          </Typography>
        ))}
        <div css={__benefitItems}>
        {highlights.map(copy => (
          <BundleCardBenefitItem text={copy} key={copy} />
        ))}
        </div>
        <BundleCardButton
          className="primary-action"
          onClick={buttonClickHandler}
          disabled={isComingSoon}
        >
          {isComingSoon ? "Coming soon" : actionCTA}
        </BundleCardButton>
      </BundleCardBaseCard>
      <div css={__imageContainer}>{image}</div>
    </div>
  );
};
